import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { titleize, underscored } from 'underscore.string';
import classnames from 'classnames';
import Switch from 'react-switch';
import { withTranslation } from 'react-i18next';
import SessionStore from 'stores/SessionStore';
import { isNumber } from 'lodash';
import CargomaticInput from '../../v2/input';
import CargomaticSelect from '../../v2/select';
import Alert from '../../ui/Alert';
import ErrorAlert from '../../ui/ErrorAlert';
import { createAccessorial, updateAccessorial, } from '../../../utils/AccessorialWebAPIUtils';
const ICON_COUNT = 36;
const shipmentTypes = [
    {
        localizationSlug: 'DRAYAGE',
        value: 'drayage',
    },
    {
        localizationSlug: 'SHORTHAUL',
        value: 'shorthaul',
    },
];
const rateTypes = [
    {
        localizationSlug: 'FLAT',
        value: 'flat',
    },
    {
        localizationSlug: 'HOURLY',
        value: 'hourly',
    },
    {
        localizationSlug: 'DAILY',
        value: 'daily',
    },
];
const unitTypes = [
    {
        localizationSlug: 'DECIMAL',
        value: 'decimal',
    },
    {
        localizationSlug: 'NUMBER',
        value: 'number',
    },
];
const ORDER_CREATION_DATE = 'ORDER_CREATION_DATE';
const PICKUP_STOP = 'PICKUP_STOP';
const DELIVERY_STOP = 'DELIVERY_STOP';
const DELIVERY_EMPTY = 'DELIVERY_EMPTY';
export const anchorEventOptions = [
    {
        localizationSlug: ORDER_CREATION_DATE,
        name: 'Order Creation Date',
        value: ORDER_CREATION_DATE,
    },
    {
        localizationSlug: PICKUP_STOP,
        name: 'Pickup Stop',
        value: PICKUP_STOP,
    },
    {
        localizationSlug: DELIVERY_STOP,
        name: 'Delivery Stop',
        value: DELIVERY_STOP,
    },
    {
        localizationSlug: DELIVERY_EMPTY,
        name: 'Delivery Empty',
        value: DELIVERY_EMPTY,
    },
];
function mapAccessorial(accessorial = {}) {
    return Object.assign({ name: '', shipment_type: 'drayage', begin_date_required: false, end_date_required: false, location_required: false, description_required: false, rate_type: 'flat', unit_type: 'decimal', admin_only: false }, accessorial);
}
class AccessorialForm extends Component {
    constructor(props) {
        const { accessorial } = props;
        super(props);
        this.handleSelectIcon = (icon_slug) => () => {
            this.setState((prevState) => {
                return {
                    accessorial: Object.assign(Object.assign({}, prevState.accessorial), { icon_slug }),
                };
            });
        };
        this.handleValueChange = (field, type) => (value) => {
            let changedValue = value;
            if (type === 'number' && isNumber(value)) {
                changedValue = Number(value);
            }
            if (type === 'option') {
                const { value: anchor_event } = value;
                changedValue = anchor_event;
            }
            this.setState((prevState) => {
                return {
                    accessorial: Object.assign(Object.assign({}, prevState.accessorial), { [field]: changedValue }),
                };
            });
        };
        this.handleSave = () => {
            const { t } = this.props;
            this.setState((prevState) => {
                const errors = this.validate(prevState.accessorial);
                const saving = Object.keys(errors).length === 0;
                return {
                    errors,
                    saving,
                };
            }, async () => {
                if (!this.state.saving) {
                    return;
                }
                let saveFn;
                if (this.state.accessorial._id) {
                    saveFn = updateAccessorial;
                }
                else {
                    saveFn = createAccessorial;
                }
                try {
                    const result = await saveFn(Object.assign(Object.assign({}, this.state.accessorial), { slug: underscored(this.state.accessorial.name.toLowerCase()) }));
                    const { entity: { accessorial }, } = result;
                    this.setState({
                        saving: false,
                        errors: {},
                        accessorial,
                        success: true,
                    }, () => {
                        setTimeout(() => {
                            this.props.onSaveSuccess(this.state.accessorial);
                        }, 400);
                    });
                }
                catch (e) {
                    console.error(e);
                    let error;
                    if (e.entity && e.entity.error.includes('duplicate key error')) {
                        if (e.entity.error.includes('charge_code')) {
                            error = t('CHARGE_CODE_ALREADY_EXISTS');
                        }
                        else {
                            error = t('ACCESSORIAL_ALREADY_EXISTS');
                        }
                    }
                    else {
                        error = t('PROBLEM_SAVING_ACCESSORIAL');
                    }
                    this.setState({
                        saving: false,
                        success: false,
                        errors: {
                            base: error,
                        },
                    });
                }
            });
        };
        this.state = {
            accessorial: mapAccessorial(accessorial),
            success: false,
            saving: false,
            errors: {},
        };
    }
    validate(accessorial) {
        const { t } = this.props;
        const { name, charge_code, rate_type, unit_type } = accessorial;
        const errors = {};
        if (!name) {
            errors.name = t('NAME_REQUIRED_ERROR');
        }
        if (!charge_code) {
            errors.charge_code = t('CHARGE_CODE_REQUIRED_ERROR');
        }
        if (!rate_type) {
            errors.rate_type = t('RATE_TYPE_REQUIRED_ERROR');
        }
        if (!unit_type) {
            errors.unit_type = t('UNIT_TYPE_REQUIRED_ERROR');
        }
        return errors;
    }
    renderSuccess() {
        const { t } = this.props;
        const { success, saving } = this.state;
        if (saving || !success) {
            return null;
        }
        return (React.createElement(Alert, { type: "success", onClose: this.handleCloseSuccessAlert, canClose: true, title: t('ACCESSORIAL_SAVED_SUCCESSFULLY') }));
    }
    renderErrors() {
        const { t } = this.props;
        const { errors } = this.state;
        const errorKeys = Object.keys(errors);
        if (errorKeys.length === 0) {
            return null;
        }
        return (React.createElement(ErrorAlert, { title: t('FIX_FOLLOWING_ISSUES'), canClose: true, onClose: this.handleHideErrorAlert },
            React.createElement("ul", { className: "ml-0 list-reset" }, errorKeys.map((errorKey) => (React.createElement("li", { key: errorKey }, this.state.errors[errorKey]))))));
    }
    render() {
        const { t } = this.props;
        const { accessorial: { name, charge_code, shipment_type, location_required, begin_date_required, end_date_required, description_required, rate_type, unit_type, admin_only, days_before_auto_decline, anchor_event, }, } = this.state;
        const isDrayage = shipment_type === 'drayage';
        const hasFinanceAdminRole = SessionStore.hasFinanceAdminRole();
        return (React.createElement("div", { className: "mb-4" },
            this.renderSuccess(),
            this.renderErrors(),
            React.createElement("div", { className: "flex flex-row" },
                React.createElement("div", { className: "w-1/2 mb-4 mr-2" },
                    React.createElement(CargomaticInput, { onChange: this.handleValueChange('name'), value: name, type: "text", label: t('NAME'), placeholder: t('ENTER_ACCESSORIAL_NAME') })),
                React.createElement("div", { className: "w-1/2 mb-4 ml-2" },
                    React.createElement(CargomaticInput, { onChange: this.handleValueChange('charge_code'), value: charge_code, type: "text", label: t('CHARGE_CODE'), placeholder: t('ENTER_ACCESSORIAL_CHARGE_CODE') }))),
            React.createElement("div", { className: "flex flex-wrap mb-4 -mx-2" },
                React.createElement("div", { className: "px-2" },
                    React.createElement(CargomaticSelect, { selected: shipment_type, fullWidth: false, label: t('SHIPMENT_TYPE'), items: shipmentTypes, showCaption: false, textKey: "localizationSlug", valueKey: "value", onSelect: (item) => {
                            this.handleValueChange('shipment_type')(item.value);
                        } })),
                React.createElement("div", { className: "px-2" },
                    React.createElement(CargomaticSelect, { selected: unit_type, fullWidth: false, className: "w-28", label: t('UNIT_TYPE'), items: unitTypes, showCaption: false, textKey: "localizationSlug", valueKey: "value", onSelect: (item) => {
                            this.handleValueChange('unit_type')(item.value);
                        } })),
                React.createElement("div", { className: "px-2" },
                    React.createElement(CargomaticSelect, { selected: rate_type, fullWidth: false, label: t('RATE_TYPE'), items: rateTypes, showCaption: false, textKey: "localizationSlug", valueKey: "value", onSelect: (item) => {
                            this.handleValueChange('rate_type')(item.value);
                        } }))),
            React.createElement("div", { className: "grid grid-cols-2 gap-2" },
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "begin_date_required", className: "flex items-center my-2" },
                            React.createElement(Switch, { checked: admin_only, id: "admin_only", onChange: this.handleValueChange('admin_only') }),
                            React.createElement("span", { className: "ml-1 text-sm form-label" }, t('ADMIN_ONLY_SELECT')))),
                    React.createElement("label", { className: "mt-4 mb-2 form-label" }, t('REQUIRED_FIELDS')),
                    React.createElement("div", { className: "grid grid-cols-2 gap-1 mb-4" },
                        React.createElement("label", { htmlFor: "begin_date_required", className: "flex" },
                            React.createElement(Switch, { checked: begin_date_required, id: "begin_date_required", onChange: this.handleValueChange('begin_date_required') }),
                            React.createElement("span", { className: "ml-1 text-sm form-label" }, t('BEGIN_DATE'))),
                        React.createElement("label", { htmlFor: "end_date_required", className: "flex" },
                            React.createElement(Switch, { checked: end_date_required, id: "end_date_required", onChange: this.handleValueChange('end_date_required') }),
                            React.createElement("span", { className: "ml-1 text-sm form-label" }, t('END_DATE')))),
                    React.createElement("div", { className: "grid grid-cols-2 gap-1 mb-4" },
                        React.createElement("label", { htmlFor: "location_required", className: "flex" },
                            React.createElement(Switch, { checked: location_required, id: "location_required", onChange: this.handleValueChange('location_required') }),
                            React.createElement("span", { className: "ml-1 text-sm form-label" }, t('LOCATION'))),
                        React.createElement("label", { htmlFor: "description_required", className: "flex" },
                            React.createElement(Switch, { checked: description_required, id: "description_required", onChange: this.handleValueChange('description_required') }),
                            React.createElement("span", { className: "ml-1 text-sm form-label" }, t('DESCRIPTION', { count: 1 }))))),
                isDrayage && (React.createElement("div", { className: "flex flex-col" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "form-label text-xs" },
                            React.createElement("span", null, t('ACCESSORIAL_REQUEST_LIMIT')),
                            ' ',
                            React.createElement("span", null, `(${t('BUSINESS_DAYS')})`)),
                        React.createElement(CargomaticInput, { type: "number", min: "0", value: days_before_auto_decline, onChange: this.handleValueChange('days_before_auto_decline', 'number'), className: "w-1/2", disabled: !hasFinanceAdminRole })),
                    React.createElement("div", null,
                        React.createElement("label", { className: "mt-4 form-label" },
                            React.createElement("span", null, t('ANCHOR_DATE'))),
                        React.createElement(CargomaticSelect, { items: anchorEventOptions, onSelect: this.handleValueChange('anchor_event', 'option'), valueKey: "value", textKey: "localizationSlug", selected: anchor_event !== null && anchor_event !== void 0 ? anchor_event : DELIVERY_STOP, disabled: !hasFinanceAdminRole }))))),
            React.createElement("label", { className: "mb-2 form-label" }, t('ICON')),
            React.createElement("div", { className: "flex flex-wrap mb-4" }, Array(ICON_COUNT)
                .fill()
                .map((_, i) => {
                const iconSlug = `icon-${i + 1}`;
                const active = this.state.accessorial.icon_slug === `icon-${i + 1}`;
                const className = classnames({
                    'border-green': active,
                    border: true,
                    'border-solid': true,
                    'border-grey-lighter': !active,
                    'bg-white': true,
                    shadow: true,
                    'w-20': true,
                    'h-20': true,
                    flex: true,
                    'justify-center': true,
                    'items-center': true,
                    'cursor-pointer': true,
                    'appearance-none': true,
                });
                const iconClassName = classnames({
                    [iconSlug]: true,
                    'icon-normal': true,
                    'mx-0': true,
                });
                return (React.createElement("div", { key: i, className: className, onClick: this.handleSelectIcon(iconSlug) },
                    React.createElement("i", { className: iconClassName })));
            })),
            React.createElement("div", { className: "flex justify-end" },
                React.createElement("button", { type: "button", onClick: this.handleSave, disabled: this.state.disabled, className: "mr-2 button button-green" }, titleize(t('SAVE'))),
                React.createElement("button", { className: "button button-secondary", disabled: this.state.saving, onClick: this.props.onCancel }, t('CANCEL')))));
    }
}
AccessorialForm.propTypes = {
    accessorial: PropTypes.shape({
        name: PropTypes.string,
        shipment_type: PropTypes.oneOf(['drayage', 'shorthaul']),
        begin_date_required: PropTypes.bool,
        end_date_required: PropTypes.bool,
        location_required: PropTypes.bool,
        description_required: PropTypes.bool,
        rate_type: PropTypes.oneOf(['flat', 'hourly', 'daily']),
        unit_type: PropTypes.oneOf(['decimal', 'integer']),
    }),
    onCancel: PropTypes.func.isRequired,
    onSaveSuccess: PropTypes.func.isRequired,
};
export default withTranslation()(AccessorialForm);
